import { useMemo } from 'react';
import type { WorkDayDto } from '../../../api/generated/v2/generated/data-contracts';
import { isWorkDay } from '../utils/isWorkDay';
import { useTimeGridStyles } from '../useTimeGridStyles';

const todayStr = new Date().toISOString().slice(0, 10);

/**
 * Returns today's date string (YYYY-MM-DD) for header column highlighting.
 */
export const todayDate = todayStr;

/**
 * Returns a map of date -> extra CSS class for date columns.
 * Non-workday dates (as determined by workWeek) get `cellNonWorkday` background.
 */
export const useDateColumnStyles = (dates: string[], workWeek: WorkDayDto[]) => {
    const styles = useTimeGridStyles();

    return useMemo(() => {
        const checkWorkDay = isWorkDay(workWeek);

        return dates.reduce<Record<string, string | undefined>>((acc, date) => {
            if (!checkWorkDay(date)) {
                acc[date] = styles.cellNonWorkday;
            }
            return acc;
        }, {});
    }, [dates, workWeek, styles.cellNonWorkday]);
};
